import React, { useState, useEffect } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const Thousandone = ({ defdata, onChange }) => {
  const getDate = () => {
    const arr = defdata.split(" ");
    return arr[0];
  };

  const [date, setDate] = useState(getDate());


  const storeDate = (selectedDate) => {
    if (selectedDate) {
      const formatted = selectedDate.format("YYYY-MM-DD") + " 00:00:00.000";
      onChange(formatted);
      setDate(selectedDate.format("YYYY-MM-DD"));
    } else {
      setDate("");
    }
  };

  return (
    <div className="form-group" style={{ paddingBottom: "10px" }}>
      <label style={{ fontWeight: 600, fontSize: "18px" }}>Select Date</label>

      <DatePicker
        style={{ width: "100%", marginTop: "5px" }}
        value={date ? dayjs(date) : null}
        onChange={storeDate}
        allowClear={true}
      />
    </div>
  );
};

export default Thousandone;



// import React, { Component } from 'react';
// import './Thousandone.css';

// export default class Thousandone extends Component {
//   constructor(props) {
//     super(props);

//     const getDate = () => {
//       const defStr = this.props.defdata;
//       const arr = defStr.split(' ');
//       return arr[0];
//     };

//     this.state = {
//       date: getDate()
//     };

//     this.storeDate = this.storeDate.bind(this);
//   }

//   storeDate(e) {
//     if (e.target.value !== "") {
//       const date = e.target.value + ' 00:00:00.000';
//       this.props.onChange(date);
//     }
//     this.setState({ date: e.target.value });
//   }

//   render() {
//     const style = {
//       border: "none",
//       background: 'none',
//       paddingLeft: '0px',
//       marginBottom: '15px'
//     };

//     return (
//       <div className='form-group' style={{ paddingBottom: "10px" }}>
//         <label htmlFor='startDate' style={{ fontWeight: '600', fontSize: '18px' }}>Select Date</label>
//         <input
//           style={style}
//           type="date"
//           id='startDate'
         
//           defaultValue={this.state.date}
//           className='form-control'
//           onChange={(e) => this.storeDate(e)}
//         />
//       </div>
//     );
//   }
// }
